import { fork, all } from 'redux-saga/effects';
import * as AppSaga from './appSaga';
import * as BudgetSaga from './budgetSaga';
import * as BudgetSagaPage from './budgetPageSaga';
import * as CommentSaga from './commentSaga';
import * as InitiativeSaga from './initiativeSaga';
import * as OfficeSaga from './officeSaga';
import * as ProjectSaga from './projectSaga';
import * as ProjectTaskSaga from './projectTaskSaga';
import * as SettingSaga from './settingSaga';
import * as UserSaga from './userSaga';

export function* rootSaga() {
	yield all([
		fork(AppSaga.watchGetDefaultSmtpConfiguration),
		fork(AppSaga.watchFetchPermissions),
		fork(AppSaga.watchGetRoles),
		fork(AppSaga.watchGetInitData),
		fork(AppSaga.watchSearchProject),
		fork(AppSaga.watchGetMainPageProjects),
		fork(AppSaga.watchGetTermsOfUse),
		fork(AppSaga.watchUnloadApp),
		fork(AppSaga.watchSetPageSize),
		fork(AppSaga.watchGetApplicationImages),
		fork(AppSaga.watchSetArchivePageSize),
		fork(AppSaga.watchGetMainPageProbeProjects),
		fork(AppSaga.watchSetExpandStateItem),
		fork(AppSaga.watchSetBreadcrumbs),
		fork(BudgetSaga.watchGetAllBudgets),
		fork(BudgetSaga.watchGetBudgetResults),
		fork(BudgetSaga.watchGetArchiveBudgets),
		fork(BudgetSagaPage.watchGetBudgetPage),
		fork(CommentSaga.watchLoadCommentsByModerator),
		fork(CommentSaga.watchUpdateComment),
		fork(CommentSaga.watchGetComment),
		fork(CommentSaga.watchUnloadComment),
		fork(InitiativeSaga.watchCreateInitiative),
		fork(InitiativeSaga.watchCreateConsultationInitiative),
		fork(OfficeSaga.watchFetchOffices),
		fork(OfficeSaga.watchGetOffice),
		fork(OfficeSaga.watchUnloadOffice),
		fork(ProjectSaga.watchFetchProjectsByType),
		fork(ProjectSaga.watchGetProject),
		fork(ProjectSaga.watchGetProjectHeader),
		fork(ProjectSaga.watchUpdateConsultationForm),
		fork(ProjectSaga.watchSaveComment),
		fork(ProjectSaga.watchAddCommentOpinion),
		fork(ProjectSaga.watchRemoveCommentOpinion),
		fork(ProjectSaga.watchAddProjectOpinion),
		fork(ProjectSaga.watchRemoveProjectOpinion),
		fork(ProjectSaga.watchGetBudgetVoteProjects),
		fork(ProjectSaga.watchFetchArchiveProjectsByType),
		fork(ProjectSaga.watchGenerateNewAuthorizeCode),
		fork(ProjectTaskSaga.watchFetchProjectTasks),
		fork(ProjectTaskSaga.watchGetProjectTask),
		fork(ProjectTaskSaga.watchSearchProjectTasks),
		fork(SettingSaga.watchGetPasswordConfigs),
		fork(SettingSaga.watchGetThematicArea),
		fork(SettingSaga.watchLoadThematicAreas),
		fork(SettingSaga.watchUnloadThematicArea),
		fork(SettingSaga.watchFetchTemplates),
		fork(SettingSaga.watchGetAttachmentConfigs),
		fork(SettingSaga.watchLoadAgreementHistories),
		fork(SettingSaga.watchGetAgreement),
		fork(SettingSaga.watchUnloadAgreement),
		fork(SettingSaga.watchGetTemplate),
		fork(SettingSaga.watchGetAuthorizationServiceSettings),
		fork(SettingSaga.watchGetCommentConfigs),
		fork(UserSaga.watchFetchUsers),
		fork(UserSaga.watchCreateUser),
		fork(UserSaga.watchUnloadUser),
		fork(UserSaga.watchFetchUser),
		fork(UserSaga.watchUpdateUser),
		fork(UserSaga.watchLoginUser),
		fork(UserSaga.watchInitialLoginUser),
		fork(UserSaga.watchLogoutUser)
	]);
}
